import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';
import { Button } from '@rsos/components/capstone/base';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import {
  createAppCIDR,
  selectManagementByApp,
  selectUserOrgByApp,
} from '@rsos/sinatra';
import { notifyError, notifySuccess } from '@rsos/utils/toastUtils';
import APP_NAME from '../../../constants/appName';
import { trackAddIPAddressSuccess } from '../IPSecurityManagementTrackings';
import { FormContainer } from './IPAddAddressForm.styles';
import { getErrorMessage, formValidationSchema } from './utils';

const IPAddAddressForm = () => {
  const dispatch = useDispatch();
  const sinatra = useSelector(state => state.sinatra);
  const org = selectUserOrgByApp(sinatra, APP_NAME);
  const management = selectManagementByApp(sinatra, org.id, APP_NAME);
  const { creating, updating } = management.whitelistedIPs;

  const [cidrValue, setCidrValue] = useState('');

  const handleIPChange = (e, setFieldValue) => {
    const { value } = e.target;

    let normalizedValues = [value];
    if (value.includes(',')) {
      normalizedValues = value
        .split(',')
        .map(val => val.trim())
        .filter(cidr => cidr !== '');
    }
    setCidrValue(value);
    setFieldValue('cidrs', [...normalizedValues]);
  };

  const handleSubmit = async values => {
    await values.cidrs.map(cidr => {
      dispatch(
        createAppCIDR(org.id, APP_NAME, {
          cidr,
          enabled: true,
        }),
      )
        .then(() => {
          trackAddIPAddressSuccess();
          notifySuccess(`${cidr}: Subnet mask added successfully.`);
        })
        .catch(action => {
          const errorMessage = getErrorMessage(action.error, values.cidr);
          notifyError(errorMessage);
        });
    });
    setCidrValue('');
  };
  const handleClearInput = () => {
    setCidrValue('');
  };

  return (
    <Formik
      initialValues={{
        cidrs: [],
      }}
      validationSchema={formValidationSchema}
      onSubmit={values => {
        handleSubmit(values);
      }}
    >
      {({ values, isValid, handleBlur, setFieldValue, errors, touched }) => (
        <Form name="ip-security-form">
          <FormContainer>
            <InputText
              id="cidr"
              name="ip_address"
              placeholder="Put in IP address here"
              type="text"
              value={cidrValue}
              isDisabled={updating}
              onChange={e => {
                handleIPChange(e, setFieldValue);
              }}
              onBlur={handleBlur}
              setFieldValue={handleClearInput}
              error={
                errors.cidrs && (!!values.cidrs || touched.cidrs)
                  ? errors.cidrs
                  : null
              }
              shouldErrorTakeSpace
            />
            <Button
              btnType="primary"
              type="submit"
              noMargin
              disabled={!isValid || cidrValue === ''}
              isLoadingProp={creating}
            >
              Add IP Address
            </Button>
          </FormContainer>
        </Form>
      )}
    </Formik>
  );
};

export default IPAddAddressForm;
